import { ELevelResult } from 'Shared/types';
export const TOOLTIP_TEXT = {
    [ELevelResult.Gene]: 'These are association tests where the unit of the test is the individual Gene.',
    [ELevelResult.Variant]: 'These are association tests where the unit of the test is the individual Variant.',
    [ELevelResult.Phenotype]: 'These are association tests where the unit of the test is the individual Phenotype.',
};
